import { SelectionType } from "../../../../data";
export function hasResolvedQAMarket(event) {
    return !!event.market && event.market.type === SelectionType.QA;
}
//# sourceMappingURL=hasResolvedQAMarket.js.map